import { IsTest, getLang } from "@/utils/tools";
import { isHtm } from "@/utils/const";
import { request } from "..";

// TODO 请求域名确定
const testOrigin = "https://test-sg-act.playerinfinite.com/";
const prodOrigin = "https://sg-act.playerinfinite.com/";
const origin = IsTest ? testOrigin : prodOrigin;
interface commomRes {
  code: number;
  msg: string;
  data?: any;
}

export interface RoleInfo{
  area_id: string;
  game_id: number;
  game_name: string;
  plat_id: string;
  role_name: string;
  zone_id: string;
  role_id: string;
}

const lang_type = getLang();
export const submitShare = async () => {
  const otherurl = 'api/flow/Wand-20231009061232-F190ca067dfd5';
  const htmlurl = 'api/flow/Wand-20230714065440-Ffb803d471bcf';
  const url = isHtm ? htmlurl: otherurl;
  return request
    .post<commomRes>(`${origin}${url}`,  {
      checkLogin: true,
      needLogin: true,
      lang_type,
    })
    .then((res) => res.data);
};

interface GetRoleInfoReq{
  area_id: string;
}
interface GetRoleInfoRes extends commomRes {
  data: {
    get_role_info: RoleInfo;
  };
}

// @see https://yapi.intlgame.com/project/1344/interface/api/83796
export const getRoleInfo = async (params: GetRoleInfoReq) => {
  const otherurl = 'api/flow/Wand-20231009072921-F6ea90b3e67b5';
  const htmlurl = 'api/flow/Wand-20230714065440-F3b4e0ed894ef';
  const url = isHtm ? htmlurl: otherurl;
  return request
    .post<GetRoleInfoRes>(`${origin}${url}`, {
      checkLogin: true,
      needLogin: true,
      lang_type,
      ...params,
    })
    .then((res) => res.data);
};

type SaveRoleInfoRes = commomRes;
// @see https://yapi.intlgame.com/project/1344/interface/api/83816
export const saveRoleInfo = async (params: Partial<RoleInfo>) => {
  const otherurl = 'api/flow/Wand-20231009073028-Fb6d69c9f2d70';
  const htmlurl = 'api/flow/Wand-20230714065440-F4a14f82acd0b';
  const url = isHtm ? htmlurl: otherurl;
  return request
    .post<SaveRoleInfoRes>(`${origin}${url}`, params)
    .then((res) => res.data);
};

interface Metrics {
  c1: string; // 用户昵称
  c2: string; // 注册日期（自然日）
  c3: string; // 所有玩法作战次数
  c4: string; // 当前主线剧情停留关卡
  c5: string; // 所有玩法胜利次数
  c6: string; // 所有玩法失败次数
  c7: string; // 所有卡池（不包括联动卡池）特别招募、普通招募、友情池的分别招募次数（包含所有的赠送招募次数）
  c8: string; // 当前角色总数（不包括联动角色）
  c9: string; // 招募次数最多的SSR/SR/R角色（不包括联动角色）
  c10: string; // 使用频率最高的企业
  c11: string; // 所有模式（除靶场）下上阵次数最多的角色（不包括联动角色）
  c12: string; // 含装备情况下战力数最高的角色（不包括联动角色）
  c13: string; // 跨战力最多并取得胜利的战役
  c14: string; // 主线单场作战时长最长的（需要显示到毫秒）
  c15: string; // 协同作战最长作战时长最长的 （需要显示到毫秒）
  c16: string; // 模拟战参加次数，模拟室达到的最高完成级别
  c17: string; // 企业塔最高企业及层数
  c18: string; // 迷失地区停留关卡
  c19: string; // 特殊拦截战的首次胜利日期
  c20: string; // 装备强化的进行次数
  c21: string; // 装备改造的进行次数
  c22: string; // 所有角色咨询次数（不包括联动角色）
  c23: string; // 好感度获得100的次数和50的次数
  c24: string; // 咨询次数获得100好感度最多的角色（不包括联动角色）
  c25: string; // 咨询次数获得50好感度最多的角色（不包括联动角色）
  c26: string; // 派遣次数
  c27: string; // 派遣中包含的角色个数
  c28: string; // 所有玩法下获得的战斗数据辑数（不含未开的补给箱）
  c29: string; // 所有玩法下获得的信用点数（不含未开的补给箱）
  c30: string; // 所有玩法下获得的芯尘数（不含未开的补给箱）
  c31: string; // 总共获得的成就次数（不包含活动成就）
  c32: string; // 战术学院
}

interface GetLoginedInitInfoRes extends commomRes {
  data: {
    get_saved_role_info: RoleInfo; // 角色信息
    metrics: Metrics; // 游戏记录信息
  };
}
// TODO htm 待确定
export const getLoginedInitInfo = async () => {
  const otherurl = 'api/flow/Wand-20231009022117-F2686ab014206';
  const htmlurl = 'api/flow/Wand-20230718073406-F3d80d0dcf5f8';
  const url = isHtm ? htmlurl: otherurl;
  return request
    .post<GetLoginedInitInfoRes>(`${origin}${url}`,  {
      checkLogin: true,
      needLogin: true,
      lang_type,
    })
    .then((res) => res.data);
};

export const enum RewardType{
  FirstLogin = 0, // 首次登录
  FirstShare = 1,// 首次分享
  FirstTest = 2, // 首次测试
  LoadCutThree = 3,// 加载完第三屏
  LoadCutFour = 4,// 加载完第四屏
  LoadCutFive = 5,// 加载完第5屏
  LoadCutSeven = 7,// 加载完第七屏
  LoadCutEight = 8,// 加载完第八屏
  LoadCutSix = 6,// 第6屏 没有具体奖励 做判断 用
  LoadCutSixBliss = 61,// 第五屏极乐净土礼包
  LoadCutSixTetra = 62,// 第五屏泰特拉礼包
  LoadCutSixMisilis= 63,// 第五屏米西利斯礼包
  LoadCutSixPilgrims = 64,// 第五屏朝圣者礼包
  LoadCutNine = 9,// 加载完第九屏
}

interface getRewardParams{
  tag: RewardType;
}
export const getReward = async (params: getRewardParams) => {
  const otherurl = 'api/flow/Wand-20231009080237-F4de24f451f23';
  const htmlurl = 'api/flow/Wand-20231009080237-F4de24f451f23';
  const url = isHtm ? htmlurl: otherurl;
  return request
    .post<commomRes>(`${origin}${url}`,  {
      checkLogin: true,
      needLogin: true,
      lang_type,
      ...params,
    })
    .then((res) => res.data);
};
